import DActivityActions from './d-activity-actions/d-activity-actions.vue';
import DActivityAuthor from './d-activity-author/d-activity-author.vue';
import DActivityAvatar from './d-activity-avatar/d-activity-avatar.vue';
import DActivityBook from './d-activity-book/d-activity-book.vue';
import DActivityTimestamp from './d-activity-timestamp/d-activity-timestamp.vue';

export default {
  components: {
    DActivityActions,
    DActivityAuthor,
    DActivityAvatar,
    DActivityBook,
    DActivityTimestamp,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    isRepost: {
      type: Boolean,
      default: false,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    activityRemoved() {
      this.$emit('activity-removed');
    },
  },
};
